/* éclore — Vitamin C landing page
   Vanilla JS, no dependencies. Ports 1:1 into a Shopify theme asset. */
function vitcInit() {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isShopify = !!(window.Shopify && window.Shopify.shop);
  /* Språksträngar för varukorgsmeddelanden (sv, de, fi) */
  var LANG = (document.documentElement.lang || 'sv').slice(0, 2);
  var I18N = {
    sv: { added: ' tillagd i varukorgen', fail: 'Kunde inte lägga i varukorgen', product: 'Produkt' },
    de: { added: ' wurde in den Warenkorb gelegt', fail: 'Konnte nicht in den Warenkorb gelegt werden', product: 'Produkt' },
    fi: { added: ' lisättiin ostoskoriin', fail: 'Ostoskoriin lisääminen epäonnistui', product: 'Tuote' }
  };
  var T = I18N[LANG] || I18N.sv;

  /* 1. Scroll reveals (staggered) */
  var rv = document.querySelectorAll('.vitc-rv, .vitc-rv-group');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('vitc-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0 });
    rv.forEach(function (el) { io.observe(el); });
  } else {
    rv.forEach(function (el) { el.classList.add('vitc-in'); });
  }

  /* 2. Hero + closer parallax (subtle, never hides merchandise) */
  var heroImg = document.querySelector('.vitc-hero-media .vitc-frame img');
  function parallax() {
    if (reduce) return;
    var y = window.scrollY;
    if (heroImg && y < window.innerHeight * 1.2) {
      heroImg.style.transform = 'scale(1.04) translateY(' + (y * 0.08) + 'px)';
    }
  }
  window.addEventListener('scroll', parallax, { passive: true });
  parallax();

  /* 3. Science rail — signature moment: sticky image stage swaps as you scroll the list */
  var rail = document.querySelector('.vitc-rail');
  if (rail) {
    var items = rail.querySelectorAll('.vitc-rail-item');
    var stageImgs = rail.querySelectorAll('.vitc-rail-stage img');
    var counter = rail.querySelector('.vitc-rail-stage .vitc-counter');
    var current = -1;
    var setActive = function (i) {
      if (i === current) return;
      current = i;
      items.forEach(function (it, k) { it.classList.toggle('vitc-is-active', k === i); });
      stageImgs.forEach(function (im, k) { im.classList.toggle('vitc-is-active', k === i); });
      if (counter) counter.textContent = ('0' + (i + 1)) + ' / ' + ('0' + items.length);
    };
    var pickActive = function () {
      var line = window.innerHeight * 0.5;
      var best = 0, bestD = Infinity;
      items.forEach(function (it, k) {
        var r = it.getBoundingClientRect();
        var d = (r.top <= line && r.bottom >= line) ? -1 : Math.min(Math.abs(r.top - line), Math.abs(r.bottom - line));
        if (d < bestD) { bestD = d; best = k; }
      });
      setActive(best);
    };
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { pickActive(); ticking = false; });
    }, { passive: true });
    pickActive();
  }

  
/* 4. Routine tabs — scoped per tablist so several routine sections can live on one page */
  document.querySelectorAll('.vitc-tabs').forEach(function (tablist) {
    var scope = tablist.parentNode;
    var tabs = tablist.querySelectorAll('button');
    tabs.forEach(function (t) {
      t.onclick = function () {
        tabs.forEach(function (x) { x.setAttribute('aria-selected', 'false'); });
        t.setAttribute('aria-selected', 'true');
        scope.querySelectorAll('.vitc-routine').forEach(function (r) {
          r.classList.toggle('vitc-is-active', r.id === t.getAttribute('aria-controls'));
        });
      };
    });
  });

  /* 5. Product filters */
  var filterBtns = document.querySelectorAll('.vitc-filters button');
  /* only the grid that owns the filters; a filter-less grid (e.g. a featured row) is left alone */
  var cards = [];
  document.querySelectorAll('[data-vitc-grid]').forEach(function (g) {
    if (g.querySelector('.vitc-filters')) {
      g.querySelectorAll('.vitc-grid .vitc-card').forEach(function (c) { cards.push(c); });
    }
  });
  filterBtns.forEach(function (b) {
    b.onclick = function () {
      filterBtns.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
      b.setAttribute('aria-pressed', 'true');
      var f = b.getAttribute('data-filter');
      var shown = 0;
      cards.forEach(function (c) {
        var ok = f === 'all' || (' ' + c.getAttribute('data-groups') + ' ').indexOf(' ' + f + ' ') > -1;
        c.classList.toggle('vitc-is-hidden', !ok);
        if (ok) shown++;
      });
      var cnt = document.querySelector('[data-shown-count]');
      if (cnt) cnt.textContent = shown;
    };
  });

  /* 6. Add to cart — real /cart/add.js on Shopify, graceful fallback in static preview */
  var toast = document.querySelector('.vitc-toast');
  function showToast(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('vitc-show');
    clearTimeout(showToast.t);
    showToast.t = setTimeout(function () { toast.classList.remove('vitc-show'); }, 2600);
  }
  function updateCount(n) {
    document.querySelectorAll('.vitc-cart-count, cart-count, .header__cart-count').forEach(function (el) { el.textContent = n; });
  }
  function addItems(items, label) {
    if (!isShopify) {
      // Static preview: simulate so the interaction is reviewable
      var cc = document.querySelector('.vitc-cart-count'); var cur = parseInt((cc && cc.textContent) || '0', 10);
      var q = items.reduce(function (s, i) { return s + i.quantity; }, 0);
      updateCount(cur + q);
      showToast(label + T.added);
      return;
    }
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () {
        return fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCount(cart.item_count);
        var drawerOpened = false;
        try {
          if (window.essentialCartApi && typeof window.essentialCartApi.openCart === 'function') { window.essentialCartApi.openCart(); drawerOpened = true; }
        } catch (err) { drawerOpened = false; }
        if (!drawerOpened) showToast(label + T.added);
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cart } }));
      })
      .catch(function () { showToast(T.fail); });
  }
  document.querySelectorAll('[data-add]').forEach(function (btn) {
    btn.onclick = function (e) {
      e.preventDefault();
      var ids = btn.getAttribute('data-add').split(',').filter(Boolean);
      addItems(ids.map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; }),
        btn.getAttribute('data-label') || T.product);
    };
  });

  /* 7. Sticky mobile CTA appears after hero */
  var sticky = document.querySelector('.vitc-sticky-cta');
  var hero = document.querySelector('.vitc-hero');
  var grid = document.getElementById('produkter') || document.querySelector('[data-vitc-grid]');
  if (sticky && hero) {
    window.addEventListener('scroll', function () {
      var past = window.scrollY > hero.offsetTop + hero.offsetHeight - 80;
      var inGrid = grid && (function () { var r = grid.getBoundingClientRect(); return r.top < window.innerHeight * 0.5 && r.bottom > window.innerHeight * 0.5; })();
      sticky.classList.toggle('vitc-show', past && !inGrid);
    }, { passive: true });
  }

  /* 8b. Theme sticky header offset for the sticky rail stage */
  function stickyTop() {
    var h = document.querySelector('#shopify-section-header, .shopify-section--header, .shopify-section-group-header-group header, header');
    if (!h) return;
    var cs = window.getComputedStyle(h);
    var top = (cs.position === 'sticky' || cs.position === 'fixed') ? h.offsetHeight : 0;
    document.documentElement.style.setProperty('--vitc-sticky-top', top + 'px');
  }
  stickyTop(); window.addEventListener('resize', stickyTop);

  /* 8. Mark fonts loaded (QA hook) */
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { document.documentElement.setAttribute('data-vitc-fonts', 'ready'); });
  }
}
vitcInit();
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', function () { vitcInit(); });
}